var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19949 1.09932L3.20292 1.10383L3.22421 1.13149C3.24474 1.15794 3.27783 1.20009 3.32318 1.25634C3.4139 1.36889 3.55342 1.53753 3.73916 1.74935C4.11111 2.17352 4.66563 2.76767 5.38201 3.42975C6.82255 4.76112 8.87608 6.32862 11.3776 7.36431C13.8631 8.39339 16.7737 8.89237 19.9983 8.13386C23.2282 7.37407 26.9178 5.31842 30.895 0.985652C31.4552 0.375358 32.4041 0.334755 33.0143 0.894962C33.6246 1.45517 33.6652 2.40405 33.105 3.01434C28.8206 7.68188 24.6293 10.1264 20.6852 11.0541C16.7357 11.9832 13.179 11.3571 10.23 10.1361C7.29687 8.92175 4.94851 7.11414 3.34582 5.63291C2.54058 4.8887 1.91314 4.21718 1.48354 3.72726C1.2685 3.48203 1.10235 3.28152 0.987593 3.13917C0.930198 3.06798 0.885601 3.01126 0.854118 2.97069C0.838375 2.9504 0.825905 2.93414 0.816747 2.92212L0.805498 2.9073L0.801744 2.90232L0.800336 2.90044C0.799763 2.89968 0.799241 2.89898 2 2L0.799241 2.89898C0.302745 2.23582 0.437854 1.29573 1.10102 0.799238C1.76359 0.303179 2.70261 0.437613 3.19945 1.09926",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2505 12.9084C18.0789 12.9084 18.7505 13.58 18.7505 14.4084V20C18.7505 20.8285 18.0789 21.5 17.2505 21.5C16.4221 21.5 15.7505 20.8285 15.7505 20V14.4084C15.7505 13.58 16.4221 12.9084 17.2505 12.9084Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.727 11.2142C9.50709 11.4931 9.91343 12.3515 9.63458 13.1316L7.69177 18.5668C7.41293 19.3469 6.55449 19.7532 5.77441 19.4743C4.99432 19.1955 4.58798 18.3371 4.86682 17.557L6.80964 12.1218C7.08848 11.3417 7.94691 10.9354 8.727 11.2142Z",
    fill: "#FFB6BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7563 11.2201C26.5323 10.9302 27.3964 11.3242 27.6864 12.1002L29.7025 17.4963C29.9925 18.2723 29.5984 19.1365 28.8224 19.4264C28.0463 19.7164 27.1822 19.3223 26.8923 18.5463L24.8761 13.1502C24.5862 12.3742 24.9802 11.5101 25.7563 11.2201Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeSlash);
export default __webpack_public_path__ + "static/media/ic_eye_slash.03263085bd6cf240ae2ebc21d899755c.svg";
export { ForwardRef as ReactComponent };